import { render, staticRenderFns } from "./EditableUpdate.vue?vue&type=template&id=4e6a16ba&scoped=true&"
import script from "./EditableUpdate.vue?vue&type=script&lang=js&"
export * from "./EditableUpdate.vue?vue&type=script&lang=js&"
import style0 from "./EditableUpdate.vue?vue&type=style&index=0&id=4e6a16ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6a16ba",
  null
  
)

export default component.exports